import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var changeProfilePasswordSlice = createSlice({
    name: "changeProfilePassword",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            state.isFetching = false;
            state.data = action.payload;
            state.isError = false;
        },
        fetchDataFailure: function(state) {
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _changeProfilePasswordSlice_actions = changeProfilePasswordSlice.actions;
export var fetchData = _changeProfilePasswordSlice_actions.fetchData, fetchDataSuccess = _changeProfilePasswordSlice_actions.fetchDataSuccess, fetchDataFailure = _changeProfilePasswordSlice_actions.fetchDataFailure, resetState = _changeProfilePasswordSlice_actions.resetState;
export default changeProfilePasswordSlice.reducer;
